import Vue from 'vue'
import SuiVue from 'semantic-ui-vue';
import PortalVue from 'portal-vue';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment'
import 'semantic-ui-css/semantic.min.css';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import App from './App.vue'
import router from './views/router'
import store from './store/index'
import Authentication from './Authentication'

Vue.use(PortalVue);

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
})

Vue.filter('formatCalendar', function(value) {
  if (value) {
    return moment(String(value)).calendar()
    // return moment(String(value)).calendar(null, {
    //   sameDay: '[Today]',
    //   nextDay: '[Tomorrow]',
    //   nextWeek: 'dddd',
    //   lastDay: '[Yesterday]',
    //   lastWeek: 'dddd',
    //   sameElse: 'DD/MM/YYYY'
    // })
  }
})
Vue.filter('formatDurationMinutes', function(value) {
  if (value) {
    return moment.utc(moment.duration(value, "minutes").asMilliseconds()).format("H[h] m[m] s[s]")
  }
})
Vue.filter('formatDurationSeconds', function(value) {
  if (value) {
    return moment.utc(moment.duration(value, "seconds").asMilliseconds()).format("HH:mm:ss")
  }
})
Vue.filter('formatDifference', function(value) {
  if (value) {
    return moment.duration(moment().diff(value)).humanize()
  }
})

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

Authentication.init().then(() => {
  Vue.use(SuiVue)
  Vue.config.productionTip = false

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

})
